<app-page [simpleTopBar]="true" [showBottomBar]="false" [title]="title">
  <nft-burn [burnNFTEntryResponses]="burnNFTEntryResponses" [post]="post" [postHashHex]="postHashHex"></nft-burn>
</app-page>
